/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderMetadataInfo
 */
export interface ProviderMetadataInfo {
    /**
     * The value of the metadata field
     * @type {string}
     * @memberof ProviderMetadataInfo
     */
    value: string;
    /**
     * The source of the metadata field
     * @type {string}
     * @memberof ProviderMetadataInfo
     */
    source: ProviderMetadataInfoSourceEnum;
    /**
     * The human-readable name for the field
     * @type {string}
     * @memberof ProviderMetadataInfo
     */
    displayName?: string;
}


/**
 * @export
 */
export const ProviderMetadataInfoSourceEnum = {
    Input: 'input',
    Token: 'token',
    Provider: 'provider'
} as const;
export type ProviderMetadataInfoSourceEnum = typeof ProviderMetadataInfoSourceEnum[keyof typeof ProviderMetadataInfoSourceEnum];


/**
 * Check if a given object implements the ProviderMetadataInfo interface.
 */
export function instanceOfProviderMetadataInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function ProviderMetadataInfoFromJSON(json: any): ProviderMetadataInfo {
    return ProviderMetadataInfoFromJSONTyped(json, false);
}

export function ProviderMetadataInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderMetadataInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'source': json['source'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
    };
}

export function ProviderMetadataInfoToJSON(value?: ProviderMetadataInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'source': value.source,
        'displayName': value.displayName,
    };
}

